module.exports = __webpack_public_path__ + "static/main_visual_sp-a5cc521e7a1599dcd3c103a0a766a305.jpg";